import { DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";

export default function ViewDocumentDialog({ handleClose, name, imageUrl }) {
  return (
        <>
          <DialogTitle>
            {name}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <iframe
              src={imageUrl}
              title={name}
              width="100%"
              height="500px"
              style={{ border: 'none' }}
            />
          </DialogContent>
        </>
  );
}